<script setup lang="ts">
import { defineProps } from "vue";
import { TarotDailyPredictionResponse } from "@/types/calculators";
import { useI18n } from "vue-i18n";

defineProps<{
  result: TarotDailyPredictionResponse;
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col md:flex-row justify-between text-brown min-h-0 md:pl-10 overflow-y-auto"
  >
    <div class="text-center">
      <img
        :src="result.card_image"
        :alt="result.name"
        class="mx-auto mb-4 md:h-[351px] md:w-[198px] w-20 h-[140px]"
      />
      <h2
        class="font-normal text-base leading-[20px] w-20 md:w-auto mx-auto mb-10 md:font-medium md:text-2xl md:leading-[32px]"
      >
        {{ result.name }}
      </h2>
    </div>

    <div class="md:overflow-y-auto w-full md:w-[67%] md:min-h-0 md:pr-10">
      <h4 class="font-semibold text-xl leading-[24px] mb-4">
        {{ t("calculators.tarot.daily-card.results.card-meaning") }}
      </h4>
      <div class="font-normal text-base leading-[20px] mb-10">
        {{ result.meaning }}
      </div>

      <h4 class="font-semibold text-xl leading-[24px] mb-4">
        {{ t("calculators.tarot.daily-card.results.today-meaning") }}
      </h4>
      <p
        class="font-normal text-base leading-[20px] mb-5"
        v-for="(item, idx) in result.today"
        :key="idx"
      >
        {{ item }}
      </p>
    </div>
  </div>
</template>
